import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

const ErrorPage: React.FC = () => {
  const location = useLocation();
  const errorMessage = location.state?.error || "An unexpected error occurred";
  const status = location.state?.status || "unknown";

  return (
    <div className="dag-statepage">
      <div className="dag-statepage__card">
        <div className="dag-statepage__icon" aria-hidden="true">
          <ExclamationTriangleIcon className="h-7 w-7" />
        </div>
        <h1 className="dag-statepage__title">Something went wrong</h1>
        {status !== "unknown" && (
          <p className="dag-statepage__text">Error code: {status}</p>
        )}
        <p className="dag-statepage__text">{errorMessage}</p>
        <div className="dag-statepage__actions">
          <Link to="/" className="btn-primary">
            Back to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
